import { Box, Grid, Typography, Button, Grid2 } from '@mui/material';
import ButtonComponent from '../ButtonComponent';

const dialButtons = [
  { label: '1', sub: '' },
  { label: '2', sub: 'ABC' },
  { label: '3', sub: 'DEF' },
  { label: '4', sub: 'GHI' },
  { label: '5', sub: 'JKL' },
  { label: '6', sub: 'MNO' },
  { label: '7', sub: 'PQRS' },
  { label: '8', sub: 'TUV' },
  { label: '9', sub: 'WXYZ' },
  { label: '*', sub: '' },
  { label: '0', sub: '' },
  { label: '#', sub: '' },
  { label: 'R', sub: '' },
  { label: '+', sub: '' },
  { label: 'C', sub: '' },
];

interface DialPadComponentProps {
  onPress?: (key: string) => void;
}

const DialPadComponent = ({ onPress }: DialPadComponentProps) => {
  return (
    <Grid2 container spacing={1} maxWidth={240} width={'100%'} display={'flex'}>
      {dialButtons.map((btn, index) => (
        <Grid2 size={4} key={index}>
          <ButtonComponent
            fullWidth
            variant="outlined"
            onClick={() => onPress?.(btn.label)}
            sx={{ height: 64, flexDirection: 'column' }}
          >
            <Typography variant="h6">{btn.label}</Typography>
            <Typography variant="caption" sx={{ lineHeight: 1 }}>
              {btn.sub}
            </Typography>
          </ButtonComponent>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default DialPadComponent;
